<template>
  <div>
    <slot v-if="initialized"></slot>
  </div>
</template>

<script>
import ComponentBase from './ComponentBase'

const layerEvents = Object.freeze([
  'click',
  'dblclick',
  'mousedown',
  'mouseover',
  'mouseout',
  'mouseup',
  'rightclick'
])

export default {
  name: 'bing-map-layer',
  mixins: [ComponentBase],
  props: {
    name: {
      type: String,
      required: false,
      default () {
        return 'layer-' + this._uid
      }
    },
    visible: {
      type: Boolean,
      required: false,
      default: () => true
    },
    zIndex: {
      type: Number,
      required: false,
      default: () => 5000
    }
  },
  data () {
    return {
      itemType: 'layer',
      allowedEvents: layerEvents
    }
  },
  watch: {
    visible (value) {
      let layer = this.getItem()
      if (layer) {
        layer.setVisible(value)
      }
    },
    zIndex (value) {
      let layer = this.getItem()
      if (layer) {
        layer.setZIndex(value)
      }
    }
  },
  inject: ['getMap'],
  provide () {
    return {
      getLayer: this.getItem
    }
  },
  methods: {
    render () {
      let layer = this.getItem()
      let map = this.getMap()

      if (map) {
        if (layer) {
          this.destroy()
        }

        layer = this.setItem(new Microsoft.Maps.Layer(this.name))
        layer.setVisible(this.visible)
        if (this.zIndex) {
          layer.setZIndex(this.zIndex)
        }

        map.layers.insert(layer)
        this.initialized = true
      }
    },
    destroy () {
      let layer = this.getItem()

      try {
        if (layer) {
          let map = this.getMap()

          if (map) {
            map.layers.remove(layer)
          }

          if (typeof layer.dispose === 'function') {
            layer.dispose()
          }
        }
      } finally {
        this.setItem(null)
      }
    }
  },
  mounted () {
    this.render()
    this.registerEvents()
  },
  beforeDestroy () {
    this.destroy()
  }
}
</script>
